export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-drag/src/constant.js
// module id = JOFX
// module chunks = 0